module.exports = __webpack_public_path__ + "img/Slide45.70cec6a6.png";